<template>
  <MyDialog
    v-model="visi"
    :title="title"
    @cancel="visi = false"
    :top="top"
    :class="{'is-iframe': !isImg}"
    append-to-body>
    <el-image 
      v-if="isImg"
      :src="url"
      :preview-src-list="[url]"
      fit="contain"/>
    <iframe 
      v-else 
      onbe 
      :src="url"
      ref="iframeRef"
      @load="iframeLoaded()" />
    <el-button
      slot="footer"
      type="success"
      size="small"
      plain
      @click="visi = false">
      关闭预览
    </el-button>
  </MyDialog>
</template>

<script>
import MyDialog from '../MyDialog/index.vue'
import { isImage } from '@/utils'
import { ViewerInstance } from './store'
export default {
  data () {
    return {
      visi: false,
      url: undefined,
      width: undefined,
      top: '5vh',
      title: '查看附件'
    }
  },
  computed: {
    isImg(){
      return isImage(this.url)
    }
  },
  components: {
    MyDialog
  },
  methods: {
    show(data){
      if(typeof data != 'object')
        return
      let keys = Object.keys(data)
      keys.forEach(key => {
        if(data[key] != undefined &&
          key in this)
          this.$set(this, key, data[key])
      })
      this.visi = true
    },
    iframeLoaded(){
      let iframeRef = this.$refs.iframeRef
      if(!iframeRef)
        return
      let cw = iframeRef.contentWindow
      let height = cw.document.documentElement.scrollHeight
      iframeRef.height = height + 'px'
    }
  },
  mounted(){
    ViewerInstance.setMounte(this)
  }
}
</script>

<style lang="scss" scoped>
.my-dialog{
  &.is-iframe{
    >>> .el-dialog__body{
      padding: 0;
      min-height: 70vh;
      display: flex;
      flex-direction: column;
    }
  }
}
.el-image{
  width: 100%;
}
iframe{
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Viewer/index.vue